import type { MaybeType } from "../types";
import { installationConfig } from "../constants/installation-config";

export const installationSetup = () => {
  let link: MaybeType<HTMLLinkElement> = document.querySelector("link[rel~='icon']");

  if (!link) {
    link = document.createElement("link") as HTMLLinkElement;
    link.rel = "icon";
    document.head.appendChild(link);
    link.href = installationConfig.favicon;
  }

  document.title = installationConfig.title;
};
